"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localeCurrencyFormat = exports.isNotEmpty = exports.getPromoValue = exports.getLowInventoryFomo = exports.currencyFormat = void 0;
var _constants = require("./constants");
var roundToTwo = function roundToTwo(num) {
  return +"".concat(Math.round("".concat(num, "e+2")), "e-2");
};
var isNotEmpty = function isNotEmpty(val) {
  return val && typeof val === 'string' && val.length !== 0;
};
exports.isNotEmpty = isNotEmpty;
var currencyFormat = function currencyFormat(amount, decimalType) {
  var onlyPrice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var priceInNumber = amount * 1; // conver string to number
  var price = priceInNumber;
  switch (decimalType) {
    case _constants.DECIMAL_TYPE.FLOAT:
      price = priceInNumber.toFixed(2);
      break;
    case _constants.DECIMAL_TYPE.ROUND:
      price = Math.round(priceInNumber);
      break;
    case _constants.DECIMAL_TYPE.FLOOR:
      price = Math.floor(priceInNumber);
      break;
    case _constants.DECIMAL_TYPE.CEIL:
      price = Math.ceil(priceInNumber);
      break;
    default:
      price = Number(amount);
      price = roundToTwo(price);
  }
  return onlyPrice ? price : price && price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
exports.currencyFormat = currencyFormat;
var localeCurrencyFormat = function localeCurrencyFormat(currencyCode, amount, display, locale) {
  var noDecimalValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var decimalType = arguments.length > 5 ? arguments[5] : undefined;
  var hideCurrency = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var defaultIDRLocale = arguments.length > 7 ? arguments[7] : undefined;
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    var formatter = '';
    var selectedLocale = '';
    if (!hideCurrency) {
      selectedLocale = defaultIDRLocale && currencyCode === 'IDR' ? 'id-id' : locale;
    }
    var format = {};
    format.currency = currencyCode || 'USD';
    if (hideCurrency === false) {
      format.style = 'currency';
      format.currencyDisplay = display;
    }
    if (noDecimalValues) {
      format.maximumFractionDigits = 0;
      format.minimumFractionDigits = 0;
    }
    try {
      formatter = new Intl.NumberFormat(selectedLocale || navigator.userLanguage || navigator.language, format);
    } catch (_unused) {
      formatter = new Intl.NumberFormat(navigator.userLanguage || navigator.language || 'en-gb', {
        style: 'currency',
        currency: currencyCode || 'USD',
        currencyDisplay: display
      });
    }
    return formatter.format(amount);
  }
  return '';
};
exports.localeCurrencyFormat = localeCurrencyFormat;
var getPromoValue = function getPromoValue() {
  var rateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var rateDiscounts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var findRoomRate = rateDiscounts.find(function (roomRate) {
    return roomRate.id === rateId;
  });
  var defaultVal = {
    title: null,
    type: null
  };
  var promo = findRoomRate || defaultVal;
  return promo;
};
exports.getPromoValue = getPromoValue;
var getLowInventoryFomo = function getLowInventoryFomo() {
  var lowInventoryFOMO = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var rateId = Number(rate === null || rate === void 0 ? void 0 : rate.id);
  var rateOptionId = rate === null || rate === void 0 ? void 0 : rate.rateOptionId;
  return lowInventoryFOMO.find(function (inventory) {
    if (inventory !== null && inventory !== void 0 && inventory.rate) {
      var _inventory$rate$rateI;
      if (inventory !== null && inventory !== void 0 && (_inventory$rate$rateI = inventory.rate[rateId]) !== null && _inventory$rate$rateI !== void 0 && _inventory$rate$rateI.option[rateOptionId]) {
        return true;
      }
    }
    return false;
  }) || {};
};
exports.getLowInventoryFomo = getLowInventoryFomo;